import React from "react";
import ProductOrOptionComponent from "../../components/ProductOrOptionComponent";

export default function Products() {

    return (
        <ProductOrOptionComponent type='products' title='Produits'/>
    );
}

